import { Directive, OnDestroy } from '@angular/core';
import { DestroyableDirective } from '@app/shared/directives/destroyable.directive';

@Directive()
export abstract class BaseContainer extends DestroyableDirective implements OnDestroy {}
